import React from "react";
import styles from "../styles/styles";

export default function BypassStatusGrid({
  title = "Bypass",
  items = []
}) {
  return (
    <div style={styles.bypassGridContainer}>

      {/* LABEL LATERAL */}
      <div style={styles.bypassGridLabel}>
        {title}
      </div>

      {/* GRID */}
      <div style={styles.bypassGridWrapper}>
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              ...styles.bypassGridItem,

              background: item.active
                ? "#ef4444"
                : "#ffffff",

              color: item.active
                ? "#ffffff"
                : "#000000",

              fontWeight: item.active
                ? "bold"
                : "normal"
            }}
          >
            {item.label}
          </div>
        ))}
      </div>

    </div>
  );
}